import type { PanelId } from "@/entities/section";

export function parseSection(pathname: string): PanelId | null {
  if (pathname.startsWith("/help")) return "help";
  if (pathname.startsWith("/school")) return "school";
  if (pathname.startsWith("/media")) return "media";
  return null;
}
